import { get } from 'lodash';
import { BorderlessDropdown } from '@klarna/bubble-ui';
import { generateCyElemId } from 'moet-test-utils/cypress/utils';
import { CY_ADDRESS_FORM_COMPONENT_IDS, tPrefix } from '../constants';

const { INPUT_COUNTRY } = CY_ADDRESS_FORM_COMPONENT_IDS;

export const countryField = (t, defaultField = { extraProps: {} }, options, isDisabled) => {
  const disabled = isDisabled || get(defaultField, 'extraProps.disabled', false);
  return {
    ...defaultField,
    component: BorderlessDropdown,
    size: 1,
    label: t(`${tPrefix}.country.label`),
    extraProps: {
      ...defaultField.extraProps,
      options,
      ...(disabled ? { disabled } : {}),
      ...generateCyElemId(INPUT_COUNTRY, window),
    },
  };
};
